<template>
  <v-alert
    v-if="alertType"
    :type="alertType"
    :dense="dense"
    :outlined="outlined"
    :text="text"
    :color="color"
    :value="show"
  >
    {{ alertText }}
  </v-alert>
  <v-alert
    v-else
    :dense="dense"
    :outlined="outlined"
    :text="text"
    :color="color"
    :value="show"
  >
    {{ alertText }}
  </v-alert>
</template>
<script>
export default {
  props: { alertType: { type: String, default: "" },
    dense: { type: Boolean, default: false },
    outlined: { type: Boolean, default: false },
    text: { type: Boolean, default: false },
    color: { type: String, default: "blue" },
    show: { type: Boolean, default: false },
    alertText: { type: String, default: "Change alertText prop to set this text" }}
}
</script>